import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './AdminSidebar.css';

const AdminSidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const adminEmail = localStorage.getItem('adminEmail') || 'admin@symbolfly.com';
  const adminName = adminEmail.split('@')[0] || 'Admin';
  const isAdmin = localStorage.getItem('isAdmin') === 'true';

  const navigationItems = [
    { path: '/admin/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/admin/users', label: 'Users', icon: '👥' },
    { path: '/admin/bookings', label: 'Bookings', icon: '🎫' },
    { path: '/admin/payments', label: 'Payments', icon: '💳' },
    { path: '/admin/chat', label: 'Live Chat', icon: '💬' },
    { path: '/admin/contacts', label: 'Contact', icon: '📝' },
    { path: '/admin/newsletter', label: 'Newsletter', icon: '📧' },
    { path: '/admin/private-jets', label: 'Private Jets', icon: '✈️' },
    { path: '/admin/reports', label: 'Reports', icon: '📈' },
  ];

  const handleNavigation = (path) => {
    navigate(path);
    // Close sidebar on mobile after navigation
    if (window.innerWidth < 1024 && onClose) {
      onClose();
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('isAdmin');
    localStorage.removeItem('adminEmail');
    localStorage.removeItem('adminUsername');
    window.dispatchEvent(new Event('adminStatusChange'));
    navigate('/admin');
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && (
        <div 
          className="admin-sidebar-overlay" 
          onClick={onClose}
          aria-label="Close sidebar"
        />
      )}

      {/* Sidebar */}
      <aside className={`admin-sidebar ${isOpen ? 'admin-sidebar-open' : ''}`}>
        {/* Close Button (Mobile Only) */}
        <button 
          className="admin-sidebar-close"
          onClick={onClose}
          aria-label="Close sidebar"
        >
          ✕
        </button>

        {/* Top Section */}
        <div className="admin-sidebar-top">
          <div className="admin-sidebar-logo">
            <div className="admin-logo-icon">✈️</div>
            <div className="admin-logo-text">
              <span className="admin-logo-brand">SymbolFly</span>
              <span className="admin-logo-subtitle">Admin</span>
            </div>
          </div>
          
          {/* Welcome Message */}
          <div className="admin-welcome-card">
            <div className="admin-welcome-icon">👋</div>
            <div className="admin-welcome-content">
              <div className="admin-welcome-text">Welcome back,</div>
              <div className="admin-welcome-name">{adminName}</div>
            </div>
          </div>
          
          <div className="admin-sidebar-divider" />
        </div>

        {/* Navigation Section */}
        <nav className="admin-sidebar-nav">
          <ul className="admin-nav-list">
            {navigationItems.map((item) => (
              <li key={item.path}>
                <button
                  className={`admin-nav-item ${isActive(item.path) ? 'admin-nav-item-active' : ''}`}
                  onClick={() => handleNavigation(item.path)}
                  aria-label={item.label}
                >
                  <span className="admin-nav-icon">{item.icon}</span>
                  <span className="admin-nav-label">{item.label}</span>
                </button>
              </li>
            ))}
          </ul>
        </nav>

        {/* Bottom Section */}
        <div className="admin-sidebar-bottom">
          <div className="admin-sidebar-divider" />
          <div className="admin-profile-card">
            <div className="admin-profile-info">
              <div className="admin-profile-avatar">
                {adminName.charAt(0).toUpperCase()}
              </div>
              <div className="admin-profile-details">
                <div className="admin-profile-name">{adminName}</div>
                <div className="admin-profile-role">Admin</div>
              </div>
            </div>
            <button
              className="admin-logout-button"
              onClick={handleLogout}
              aria-label="Logout"
            >
              🚪 Logout
            </button>
          </div>
        </div>
      </aside>
    </>
  );
};

export default AdminSidebar;

